import Plot from "react-plotly.js";
import { useTheme } from "../../theme/useTheme";

const Scattergraph = (props: any) => {
  // Sort props.data[0].text values alphabetically and rearrange props
  const sortedIndices = props.data[0].text
    .map((text: string, index: number) => ({ text, index }))
    .sort((a: { text: string }, b: { text: string }) =>
      a.text.localeCompare(b.text),
    )
    .map((item: { index: number }) => item.index);

  const sortedText = sortedIndices.map(
    (index: number) => props.data[0].text[index],
  );
  const sortedY = sortedIndices.map((index: number) => props.data[0].y[index]);

  const { mode } = useTheme();
  const max = Math.ceil(Math.max(...sortedY)) + 5;
  const min = Math.floor(Math.min(...sortedY)) - 5;
  const yRange = [min, max];

  const layout = {
    paper_bgcolor: "rgba(0,0,0,0)",
    plot_bgcolor: "rgba(0,0,0,0)",
    modebar: {
      bgcolor: "rgba(0,0,0,0)",
      color: mode === "dark" ? "#9ca3af" : "#6b7280",
      activecolor: mode === "dark" ? "#e5e7eb" : "#111827",
    },
    margin: { t: 50, b: 50, l: 50, r: 50 },
    xaxis: {
      showline: true,
      linecolor: mode === "dark" ? "#6b7280" : "black",
      linewidth: 2,
      gridcolor: mode === "dark" ? "#374151" : "#e5e7eb",
      tickfont: { color: mode === "dark" ? "#d1d5db" : "#374151", size: 11 },
      tickangle: -45,
    },
    yaxis: {
      range: yRange,
      showline: true,
      linecolor: mode === "dark" ? "#6b7280" : "black",
      linewidth: 2,
      gridcolor: mode === "dark" ? "#374151" : "#e5e7eb",
      tickfont: { color: mode === "dark" ? "#d1d5db" : "#374151" },
    },
  };

  return (
    <Plot
      key={mode}
      data={[
        {
          x: sortedText,
          y: sortedY,
          text: sortedText,
          customdata: sortedText,
          type: "scatter",
          mode: "markers",
          marker: { color: mode === "dark" ? "#60a5fa" : "#2563eb", size: 8 },
          hovertemplate: "<b>%{customdata}</b><br>Y: %{y:.2f}<extra></extra>",
          hoveron: "points",
        },
      ]}
      layout={{
        ...layout,
        autosize: true,
        margin: { l: 50, r: 50, t: 50, b: 120 },
        hoverlabel: {
          bgcolor: mode === "dark" ? "#1f2937" : "#ffffff",
          bordercolor: mode === "dark" ? "#9ca3af" : "#000000",
          font: { color: mode === "dark" ? "#f3f4f6" : "#111827", size: 12 },
          namelength: -1,
        },
        xaxis: {
          ...layout.xaxis,
          automargin: true,
          tickangle: -45,
          showticklabels: true,
          title: {
            text: props.xaxislabel,
            font: { color: mode === "dark" ? "#e5e7eb" : "#111827" },
          },
        },
        yaxis: {
          ...layout.yaxis,
          automargin: true,
          title: {
            text: props.yaxislabel,
            font: { color: mode === "dark" ? "#e5e7eb" : "#111827" },
          },
        },
      }}
      config={{
        responsive: true,
        displayModeBar: true,
        displaylogo: false,
        modeBarButtons: [["toImage"]],
        modeBarButtonsToRemove: [
          "zoomIn2d",
          "zoomOut2d",
          "resetScale2d",
          "lasso2d",
          "select2d",
          "hoverClosestCartesian",
          "hoverCompareCartesian",
          "sendDataToCloud",
        ],
        toImageButtonOptions: {
          format: "png",
          filename: `${props.title.split(" ").join("_")}`,
        },
      }}
      style={{ width: "100%", height: "100%" }}
      useResizeHandler={true}
    />
  );
};

export default Scattergraph;
